import React from 'react';

const ContentDivider = () => {
  return <span className="content-divider" />;
};

export default ContentDivider;
